import React from 'react';
import CardsBodyWrapper from '../CardsBodyWrapper';
import { TitleContainer, DescriptionContainer } from './styles';

const BlogCard = (props) => {
  const { title, description, simpleResponsive = false, bodyType } = props;
  const className = `${simpleResponsive ? 'simple-responsive' : ''} ${
    bodyType === 'simple' ? 'simple-card' : ''
  }`;
  return (
    <div
      role="listitem"
      data-testid="card-body-wrapper"
      className={`card--body-wrapper ${className}`}
    >
      {title && (
        <TitleContainer className={`cards-blog--title ${className}`}>
          <p className="font-heading-md">{title}</p>
        </TitleContainer>
      )}
      {description && (
        <DescriptionContainer className={`cards-blog--description ${className}`}>
          <p>{description}</p>
        </DescriptionContainer>
      )}
    </div>
  );
};

export default CardsBodyWrapper(BlogCard);
